
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/5-epic-trips-for-two-under-500-pounds",
      function () {
        return require("private-next-pages/blog/5-epic-trips-for-two-under-500-pounds.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/5-epic-trips-for-two-under-500-pounds"])
      });
    }
  